import {  gsap } from "gsap";

export class Helper {

    /**
     * Cleans the timeline.
     * @param tl Timeline, gsap.core.Timeline, gsap.core.Timeline or undefined.
     * @param tlReplace Replace timeline value.
     * @param playToEnd boolean, use this if you want to jump to end of the timeline before killing it.
     * @returns {undefined | Timeline}
    */
    public static setTimeline(tl?: gsap.core.Timeline | undefined, tlReplace?: gsap.core.Timeline | undefined, playToEnd: boolean = false): gsap.core.Timeline {
        if (!tl) return tlReplace ? tlReplace : new gsap.core.Timeline();

        if (playToEnd) tl.totalProgress(1);

        tl.pause();
        tl.kill();
        tl.clear(true);
        tl = undefined;

        return  tlReplace ? tlReplace : new gsap.core.Timeline();
    }

    /**
     * Kills the timeline and destroys DisplayObject when the animation is done. 
     * @param itme PIXI.DiplayObject.
     * @returns {gsap.core.Timeline}
    */
    public static temporaryItemTl(item: PIXI.DisplayObject): gsap.core.Timeline {
        const tl = new gsap.core.Timeline({
            onComplete: () => {
                tl.kill();
                item.destroy();
            }
        });
        return tl;
    }

    /**
     * Shortcut for creating a simple box graphic.
     * @param color Default: "0xFFFFFF"
     * @param alpha Default: 1
     * @param position_X Default: 0
     * @param position_Y Default: 0
     * @param width Default: 0
     * @param height Default: 0
     * @returns {PIXI.Graphics}
    */
    public static createBasicGraphic(color: number = 0xFFFFFF, alpha: number = 1, position_X: number = 0, position_Y: number = 0, width: number = 0, height: number = 0): PIXI.Graphics {
        const graphicBg: PIXI.Graphics = new PIXI.Graphics();
        graphicBg.beginFill(color, alpha);
        graphicBg.drawRect(position_X, position_Y, width, height);
        graphicBg.endFill();
        return graphicBg;
    }

    /**
     * A PollyFill, Internet Explorer does not support Object.Assign()
     * @param from Object to copy from.
     * @param args T. Define at RunTime on what type of Object we are are going to copy.
     * @returns {T} <T> Any.
    */
    public static assignObj<T>(from: Object, args: T): T {
        let to: any = Object(from);
        for (var index = 1; index < arguments.length; index++) {
            let nextSource = arguments[index];

            if (nextSource !== null && nextSource !== undefined) {
                for (var nextKey in nextSource) {
                    // Avoid bugs when hasOwnProperty is shadowed
                    if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                        to[nextKey] = nextSource[nextKey];
                    }
                }
            }
        }
        return to;
    }



    /**  
     * Use this method to catch the position from the TransformWorld between two objects in two different containers/layers.
     * @param objToSet Uses the  PIXI.DisplayObject's container to remove the it's offset.
     * @param objToMimic PIXI.DisplayObject to copy the position from.
     * @param position — The world origin to calculate from.
     * @returns {PIXI.Point} Mimiced position.
    */
    public static copyLocalPosition(objToSet: PIXI.DisplayObject, objToMimic: PIXI.DisplayObject | undefined, position?: PIXI.Point | undefined): PIXI.Point {
        return <PIXI.Point>objToSet.parent.toLocal(objToSet.parent.position, objToMimic, position);
    }

    /**
    * Super simpleLoop.
    * @param times number
    * @param cb Funcion
    */
    public static simpleLoop<T>(times:number, callback:Function): void {
        for (let i = times; i; i--) callback(times - i);
    }

    /**  
   * Trigger the function/method if it exist
   * Example usage -> "Helper.triggerIfExist(this.foo,bar), this.foo = Function, bar == []:any"
   * @param func Function | undefined
   * @param value ...:any
   * @returns {void}
  */
    public static triggerIfExist(func: Function | undefined, ...value: any): void { func ? func(value[0]) : undefined; };
    
     /**  
     * Return value if extist, otherwise fallbackValue.
     * @param val any
     * @param fallback any
     * @returns {any}
    */
      public static fetchOrApply(val: any, fallback:any): any {
        return val == undefined ? fallback  : val;
    }

    // Test #SH
    public static clicker(obj:PIXI.DisplayObject, onClick:Function): void {
        obj.interactive = true;
        obj.off("pointerdown");
        obj.once('pointerdown', () => onClick());
    }

    public static ResizeText(txt:PIXI.Text,clamp:number){
        if(txt.width >= clamp) txt.scale.set(clamp/txt.width)
    }
}